import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checked",
  "use": "svg_checked-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 14\" id=\"svg_checked\"><path d=\"m19.03 1.28-12 12a.75.75 0 0 1-1.06 0L.72 8.03a.75.75 0 1 1 1.06-1.06l4.72 4.72L17.97.22a.75.75 0 1 1 1.06 1.06Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol